/*
 * Copyright (c) 2008-2020 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

var localStoragePrefix

/**
 * Store an object persistently in the Database
 * @param key the object key
 * @param object the data object
 * be careful when changing this logic, there is a custom other implementation in join.jsp as well...
 */
function setStorageObject(key, object) {
  // deleteStorageObject(key); // not needed - and it may happen that this function is interrupted or the app quits
  if (localStoragePrefix) {
    key = localStoragePrefix + ":::" + key
  }
  logTrace("storing storage object: " + key)
  if (localStorageAvailable()) {
    setLocalStorageObject(key, object)
  } else {
    createCookie(key, JSON.stringify(object), 100)
  }
}

/**
 * Retrieve an object from the Database
 * @param key the object key
 * @param defaultValue the default value to return, in case the key is not found in the storage
 */
function getStorageObject(key, defaultValue) {
  var returnValue = undefined
  // see also settings.je
  if (localStoragePrefix) {
    key = localStoragePrefix + ":::" + key
  }
  logTrace("getting storage object: " + key)
  if (localStorageAvailable()) {
    returnValue = getLocalStorageObject(key, defaultValue)
  } else {
    try {
      var value = readCookie(key)
      returnValue = value ? JSON.parse(value) : defaultValue
    } catch (e) {
      logError("unable to parse JSON String " + e)
      returnValue = defaultValue
    }
  }
  return returnValue
}

/**
 * Delete a storage object from the Database
 * @param key - the object key
 */
function deleteStorageObject(key) {
  if (localStoragePrefix) {
    key = localStoragePrefix + ":::" + key
  }
  logTrace("deleting storage object: " + key)
  if (localStorageAvailable()) {
    deleteLocalStorageObject(key)
  } else {
    deleteCookie(key)
  }
}

/**
 * Get all storage keys from the Database
 */
function getStorageObjectKeys() {
  var keys
  logTrace("retrieving a list of all storage objects")
  if (localStorageAvailable()) {
    keys = getLocalStorageObjectKeys()
  } else {
    keys = getCookieNames()
  }
  // when prefixes are used, remove them here
  return _.map(keys, function(k) {
    if (beginsWith(localStoragePrefix + ":::", k)) {
      return k.substr(localStoragePrefix.length + 3)
    } else if (k.indexOf(":::") >= 0) {
      // skip this key if it has a prefix of another client
      return null
    }
    return k
  })
}

/**
 * Deletes the content from the html5 local storage Database with the localStoragePrefix of this client
 */
function deleteLocalStorage() {
  try {
    getStorageObjectKeys().forEach(deleteStorageObject)
  } catch (e) {
    logError("can not clear local storage cache")
  }
}

/**
 * Do not use this internal function!
 * store an object in the html5 storage space
 * @param key the object key
 * @param object the data object
 */
function setLocalStorageObject(key, object) {
  try {
    localStorage.setItem(key, JSON.stringify(object))
  } catch (e) {
    logError("Can not write to Local Storage ", e)
  }
}

/**
 * Do not use this internal function!
 * get an object from the html5 storage space
 * @param key the object key
 * @param defaultValue the default value to return, in case the key is not found in the storage
 */
function getLocalStorageObject(key, defaultValue) {
  try {
    var value = localStorage.getItem(key)
    if (!value) {
      return defaultValue
    }
    return JSON.parse(value)
  } catch (e) {
    logError("unable to parse JSON String " + e)
    return defaultValue
  }
}

/**
 * Do not use this internal function!
 * delete an object from the html5 storage space
 * @param key the object key
 */
function deleteLocalStorageObject(key) {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    logError("unable to remove local storage object " + e)
  }
}

/**
 * Do not use this internal function!
 * get all keys from html5 storage space
 */
function getLocalStorageObjectKeys() {
  var keys = []
  try {
    for (var i = 0; i <= localStorage.length - 1; i++) {
      keys[i] = localStorage.key(i)
    }
  } catch (e) {
    logError("unable to retrieve local storage object keys")
  }
  return keys
}

/**
 * Checks, whether the browser supports the html5 localStorage functionality
 *
 * And, check, if localStorage is enabled AND can be used, see https://stackoverflow.com/a/16427747/1480587
 */
function localStorageAvailable() {
  var t = "teambits ROX ...! :-)"
  try {
    localStorage.setItem(t, t)
    localStorage.removeItem(t)
    return true
  } catch (e) {
    return false
  }
}

/**
 * Do not use this internal function!
 * Store a value in a cookie
 * @param name - the name of the cookie
 * @param value - the value of the cookie
 * @param days - validity of the cookie in days
 */
function createCookie(name, value, days) {
  var expires = ""
  if (days) {
    var date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = "; expires=" + date.toGMTString()
  }
  document.cookie = name + "=" + escape(value) + expires + "; path=/"
}

/**
 * Do not use this internal function!
 * Obtain a value from a cookie
 * @param name - the name of the cookie
 */
function readCookie(name) {
  var nameEQ = name + "="
  var ca = document.cookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == " ") {
      c = c.substring(1, c.length)
    }
    if (c.indexOf(nameEQ) == 0) {
      return unescape(c.substring(nameEQ.length, c.length))
    }
  }
  return null
}

/**
 * get the names of all defined cookies
 */
function getCookieNames() {
  var names = []
  var ca = document.cookie.split(";")
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == " ") {
      c = c.substring(1, c.length)
    }
    var j = c.indexOf("=")
    names.push(c.substr(0, j))
  }
  return names
}

/**
 * Do not use this internal function!
 * Delete a cookie by setting its expiration date to the current time
 * @param name - the name of the cookie
 */
function deleteCookie(name) {
  createCookie(name, "", 0)
}

/**
 * removes all form data from the local cache
 */
function deleteForms() {
  log.info("removing all forms")

  var keys = getStorageObjectKeys()
  for (var i = 0; i < keys.length; i++) {
    if (
      typeof keys[i] === "string" &&
      keys[i].substr(0, 4) === "form"
    ) {
      deleteStorageObject(keys[i])
    }
  }
}

/**
 * removes all notepad data from the local cache
 */
function deleteNotepadItems() {
  log.info("removing all notes")

  var keys = getStorageObjectKeys()
  for (var i = 0; i < keys.length; i++) {
    if (keys[i].substr(0, 7) == "notepad") {
      deleteStorageObject(keys[i])
    }
  }

  // refresh notepad if necessary
  /*if (activeContainer == "notepadContainer") {
		startAction("$notepad");
	}*/
}

if (typeof exports === "object") {
  exports.setStorageObject = setStorageObject
  exports.getStorageObject = getStorageObject
  exports.deleteStorageObject = deleteStorageObject
  exports.getStorageObjectKeys = getStorageObjectKeys
}
